import gql from 'graphql-tag'

export const GET_PAYMENT_TYPES_PAGINATION_QUERY = gql`
  query GetPaymentTypesPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getPaymentTypes (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        title
        static
        category {
          id
          title
          static
        }
      }
    }
  }
`
